module.exports = __webpack_public_path__ + "media/images/edit_fact_sheet-15bbc3629fed95aa9465743625e6d26a.png";